import { render, staticRenderFns } from "./toufa.vue?vue&type=template&id=75d7193e&"
import script from "./toufa.vue?vue&type=script&lang=ts&"
export * from "./toufa.vue?vue&type=script&lang=ts&"
import style0 from "./toufa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports